import SEOHead from '../components/SEOHead';

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="text-xl font-semibold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-slate-600 leading-relaxed">{children}</div>
  </div>
);

const Terms = () => (
  <>
    <SEOHead
      title="Terms of Service"
      description="Terms governing access to and use of the IDGate identity check-in platform."
      url="https://idgate.in/terms"
      noindex
    />

    <div className="border-b border-slate-200 bg-white">
      <div className="container-custom py-16 lg:py-20">
        <div className="mx-auto max-w-3xl">
<h1 className="text-4xl font-bold tracking-tight text-slate-900">Terms of Service</h1>
          <p className="mt-3 text-slate-500 text-sm">Effective date: 15 April 2026</p>
        </div>
      </div>
    </div>

    <div className="bg-surface-page py-16">
      <div className="container-custom">
        <div className="mx-auto max-w-3xl">

          <Section title="Acceptance">
            <p>
              By creating an IDGate account or using the IDGate platform (the &ldquo;Service&rdquo;), you agree
              to these Terms of Service (&ldquo;Terms&rdquo;). If you are using the Service on behalf of an
              organisation, you represent that you have authority to bind that organisation to these
              Terms.
            </p>
          </Section>

          <Section title="The Service">
            <p>
              IDGate provides a QR-based Aadhaar check-in platform that enables operators to
              collect verified guest identities and custom check-in data. The identity verification
              component is powered by UIDAI&rsquo;s official Aadhaar authentication infrastructure.
              IDGate does not operate a parallel identity system &mdash; it routes verification requests
              through UIDAI.
            </p>
          </Section>

          <Section title="Operator responsibilities">
            <p>Operators who use IDGate to collect guest data agree to:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>
                Use the Service only for lawful purposes and in compliance with applicable law,
                including the Aadhaar Act, 2016 and the DPDP Act, 2023.
              </li>
              <li>
                Not use IDGate to collect data for purposes not disclosed to guests at the time of
                check-in.
              </li>
              <li>
                Maintain appropriate technical and organisational measures to protect guest records
                received via webhook or Google Sheet.
              </li>
              <li>
                Obtain any additional consents required by applicable law beyond what IDGate
                captures through the Aadhaar app flow.
              </li>
            </ul>
          </Section>

          <Section title="UIDAI compliance">
            <p>
              The Service operates under agreements with UIDAI. Operators must not attempt to
              circumvent, replicate, or reverse-engineer any part of the Aadhaar verification flow.
              Any misuse that results in action by UIDAI against IDGate may result in immediate
              termination of the operator&rsquo;s account.
            </p>
          </Section>

          <Section title="Sandbox and production">
            <p>
              Accounts on the free pilot plan operate in a sandbox environment against UIDAI&rsquo;s
              test infrastructure. Connecting to UIDAI&rsquo;s production servers requires an upgrade.
              IDGate reserves the right to verify the operator&rsquo;s business category and intended
              use before granting production access.
            </p>
          </Section>

          <Section title="Acceptable use">
            <p>You may not use the Service to:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Verify identities without the individual&rsquo;s knowledge and consent.</li>
              <li>Store, aggregate, or re-identify Aadhaar numbers or biometric data.</li>
              <li>Interfere with or disrupt the Service or UIDAI&rsquo;s infrastructure.</li>
              <li>Resell or sublicense access to the Service without written permission.</li>
            </ul>
          </Section>

          <Section title="Intellectual property">
            <p>
              IDGate and its licensors own all rights in the Service, including the console,
              API, and associated software. These Terms do not grant you any rights to IDGate&rsquo;s
              intellectual property beyond a limited licence to use the Service as described here.
            </p>
          </Section>

          <Section title="Termination">
            <p>
              Either party may terminate these Terms at any time. IDGate may suspend or terminate
              accounts that violate these Terms, abuse the Service, or place IDGate&rsquo;s UIDAI
              authorisation at risk. Upon termination, operator data will be deleted per the
              Privacy Policy retention schedule.
            </p>
          </Section>

          <Section title="Limitation of liability">
            <p>
              To the maximum extent permitted by law, IDGate&rsquo;s liability for any claim arising out
              of or relating to these Terms is limited to the fees paid by the operator in the 12
              months preceding the claim. IDGate is not liable for indirect, incidental, or
              consequential damages.
            </p>
          </Section>

          <Section title="Governing law">
            <p>
              These Terms are governed by the laws of India. Disputes shall be subject to the
              exclusive jurisdiction of the courts in Bengaluru, Karnataka.
            </p>
          </Section>

          <Section title="Contact">
            <p>
              Questions about these Terms should be sent to{' '}
              <a href="mailto:sales@idgate.in" className="text-primary-700 hover:underline">
                sales@idgate.in
              </a>
              .
            </p>
          </Section>

        </div>
      </div>
    </div>
  </>
);

export default Terms;
